/**
 * Shopify Wishlist Module
 * Custom wishlist based on localStorage and product handles.
 */
;(function (window, $) {
  'use strict';

  if (!$) {
    return;
  }

  var Wishlist = {
    key: 'user_wishlist',
    countKey: 'user_wishlist_count',
    _storageReady: null,
    _eventsBound: false,
    _memoryList: [],

    hasStorage: function () {
      if (this._storageReady !== null) {
        return this._storageReady;
      }

      try { 
        var testKey = '__wishlist_test__';
        localStorage.setItem(testKey, '1');
        localStorage.removeItem(testKey);
        this._storageReady = true;
      } catch (error) {
        this._storageReady = false;
      }

      return this._storageReady;
    },

    normalizeHandle: function (handle) {
      if (typeof handle !== 'string') {
        return '';
      }
      return $.trim(handle).toLowerCase();
    },

    normalizeList: function (rawList) {
      var input = Array.isArray(rawList) ? rawList : [];
      var output = [];
      var map = {};
      var i;

      for (i = 0; i < input.length; i += 1) {
        var handle = this.normalizeHandle(input[i]);
        if (!handle || map[handle]) {
          continue;
        }
        map[handle] = true;
        output.push(handle);
      }

      return output;
    },

    parseStoredList: function (raw) {
      if (!raw) {
        return [];
      }

      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return parsed;
        }
        if (parsed && Array.isArray(parsed.handles)) {
          return parsed.handles;
        }
      } catch (error) {
        return [];
      }

      return [];
    },

    persistList: function (list) {
      var normalized = this.normalizeList(list);

      if (this.hasStorage()) {
        if (normalized.length) {
          localStorage.setItem(this.key, JSON.stringify(normalized));
        } else {
          localStorage.removeItem(this.key);
        }
        localStorage.setItem(this.countKey, String(normalized.length));
      } else {
        this._memoryList = normalized.slice(0);
      }

      return normalized;
    },

    getList: function () {
      var rawList = this.hasStorage()
        ? this.parseStoredList(localStorage.getItem(this.key))
        : this._memoryList.slice(0);

      return this.normalizeList(rawList);
    },

    saveList: function (list, options) {
      var normalized = this.persistList(list);
      this.updateCounter(normalized.length);
      this.syncButtons(normalized);

      if (!(options && options.silent)) {
        this.emitUpdated(normalized);
      }

      return normalized;
    },

    replace: function (list, options) {
      return this.saveList(list, options);
    },

    getCount: function () {
      return this.getList().length;
    },

    has: function (handle) {
      var normalizedHandle = this.normalizeHandle(handle);
      if (!normalizedHandle) {
        return false;
      }
      return this.getList().indexOf(normalizedHandle) !== -1;
    },

    add: function (handle) {
      var normalizedHandle = this.normalizeHandle(handle);
      var list = this.getList();

      if (!normalizedHandle || list.indexOf(normalizedHandle) !== -1) {
        return list.length;
      }

      list.push(normalizedHandle);
      this.saveList(list);
      return list.length;
    },

    remove: function (handle) {
      var normalizedHandle = this.normalizeHandle(handle);
      var list = this.getList();
      var index = list.indexOf(normalizedHandle);

      if (index === -1) {
        return list.length;
      }

      list.splice(index, 1);
      this.saveList(list);
      return list.length;
    },

    toggle: function (handle) {
      if (this.has(handle)) {
        this.remove(handle);
        return false;
      }

      this.add(handle);
      return true;
    },

    clear: function () {
      this.saveList([]);
    },

    updateCounter: function (count) {
      var value = typeof count === 'number' ? count : this.getCount();
      $('.wishlist-counter').text(value);
    },

    applyButtonState: function ($button, isActive) {
      $button.toggleClass('is-active', isActive);
      $button.attr('aria-pressed', isActive ? 'true' : 'false');
    },

    syncButtons: function (list) {
      var handles = Array.isArray(list) ? list : this.getList();
      var map = {};
      var i;

      for (i = 0; i < handles.length; i += 1) {
        map[handles[i]] = true;
      }

      var self = this;
      $('.wishlist-btn').each(function () {
        var $button = $(this);

        // Item removal buttons on wishlist page are managed by wishlist-page.js.
        if ($button.closest('.wishlist-tile-container').length) {
          return;
        }

        var handle = self.normalizeHandle($button.data('product-handle'));
        if (!handle) {
          return;
        }

        self.applyButtonState($button, !!map[handle]);
      });
    },

    animateButton: function ($button) {
      $button.addClass('loading-wishlist adding-wishlist');

      window.setTimeout(function () {
        $button.removeClass('loading-wishlist');
      }, 600);

      window.setTimeout(function () {
        $button.removeClass('adding-wishlist');
      }, 1200);
    },

    emitUpdated: function (list) {
      $(document).trigger('wishlist:updated', [
        {
          list: list.slice(0),
          count: list.length
        }
      ]);
    },

    bindEvents: function () {
      if (this._eventsBound) {
        return;
      }

      var self = this;

      $(document).on('click.wishlist', '.wishlist-btn', function (event) {
        var $button = $(this);

        // Wishlist page remove buttons have their own dedicated behavior.
        if ($button.closest('.wishlist-tile-container').length) {
          return;
        }

        var handle = self.normalizeHandle($button.data('product-handle'));
        if (!handle) {
          return;
        }

        event.preventDefault();

        var isAdded = self.toggle(handle);
        self.syncButtons();
        self.applyButtonState($button, isAdded);
        self.animateButton($button);
      });

      if (window.addEventListener) {
        window.addEventListener('storage', function (event) {
          if (event.key !== self.key) {
            return;
          }
          var list = self.getList();
          self.updateCounter(list.length);
          self.syncButtons(list);
          self.emitUpdated(list);
        });
      }

      this._eventsBound = true;
    },

    init: function () {
      var list = this.getList();
      this.updateCounter(list.length);
      this.syncButtons(list);
      this.bindEvents();
    }
  };

  window.Wishlist = Wishlist;

  $(document).ready(function () {
    Wishlist.init();
  });
})(window, window.jQuery);
